import React from "react";
import { Link, Popover, makeStyles } from "@material-ui/core";
import { getItem } from "utilities/items";

const useStylesItemComponent = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  root: {
    backgroundColor: 'transparent',
  }
}));

const ItemComponent: React.FC<{item:string,rarity:string,key:any} & React.HTMLProps<HTMLDivElement>> = ({item,rarity,key,style,onClick}) => {
  const classes = useStylesItemComponent();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  let _item = getItem(item);

  return <div key={key}>
    <Link href="#"
      aria-owns={open ? 'mouse-over-popover' : undefined}
      aria-haspopup="true"
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
      onClick={(e:any)=>{
        e.preventDefault();
        if(onClick){
          onClick(e);
        }
      }}
      style={{...style,color:rarity == "Legendary" ? "#E38F35" : rarity == "Epic" ? '#8D11BE' : rarity == 'Rare' ? '#006EA7' : "#5B933D"}}
      >{item}
    </Link>
    <Popover
        className={classes.popover}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{classes:{root:classes.root}}}
        onClose={handlePopoverClose}
        disableRestoreFocus
        elevation={0}
      >
        <img src={_item} />
      </Popover>
  </div>
}

export {ItemComponent}